/* eslint-disable camelcase */
import { CatalogType, getQueryParam, QueryParameters } from '@browsing/utils';
export const checkIsCrossCampaignTrackingProperty = (isCrossCampaign) => isCrossCampaign ? '1' : '0';
export const checkIsGetInspiredTrackingProperty = (isGetInspired) => isGetInspired ? '1' : '0';
export const getGA4Context = (options = {}) => {
    var _a;
    if (options.isExclusiveItem) {
        return 'plus_exclusive';
    }
    /**
     * TODO: Remove these three conditions once the catalog type
     *  is properly passed across the whole journey.
     */
    if (options.isCrossCampaign) {
        return 'cross_campaign_filter';
    }
    if (options.isTopPickArticle) {
        return 'tp4u';
    }
    if (options.isSacCarousel) {
        return 'sac_carousel';
    }
    if (options.isSearchCatalog) {
        return 'search_catalog';
    }
    const catalogType = options.catalogType || getQueryParam(QueryParameters.CatalogType);
    const map = {
        [CatalogType.CrossCampaign]: 'cross_campaign_filter',
        [CatalogType.TopPicks]: 'tp4u',
        [CatalogType.BiggestDiscount]: 'best_deal_carousel',
        [CatalogType.SimilarArticles]: 'similar_articles_recommendation',
    };
    return (_a = map[catalogType]) !== null && _a !== void 0 ? _a : 'general_campaign';
};
export const TRACK_TRAFFIC_SOURCES = ['notification'];
export const getElementFromTrafficSource = (trafficSource) => {
    if (trafficSource &&
        TRACK_TRAFFIC_SOURCES.includes(trafficSource)) {
        return trafficSource;
    }
    return null;
};
export const toPageTypeLvl1 = (page) => {
    switch (page) {
        case 'catalog':
            return 'catalog';
        case 'pdp':
            return 'pdp';
        case 'mylounge':
            return 'campaign_overview';
        case 'plus':
            return 'plus';
        case 'new_deals':
            return 'new_deals';
        default:
            return null;
    }
};
const StockStatus = {
    RESERVED: 'RESERVED',
    SOLD_OUT: 'SOLD_OUT',
    AVAILABLE: 'AVAILABLE',
};
const checkAvailability = (stockStatus) => {
    const availability = {
        [StockStatus.AVAILABLE]: '0',
        [StockStatus.RESERVED]: '1',
        [StockStatus.SOLD_OUT]: '2',
    };
    return availability[stockStatus] || '0';
};
export const toItemAvailability = (stockStatus) => {
    const availability = {
        [StockStatus.AVAILABLE]: 'available',
        [StockStatus.RESERVED]: 'reserved',
        [StockStatus.SOLD_OUT]: 'sold_out',
    };
    return availability[stockStatus] || null;
};
export const formatItemName = ({ nameCategoryTag, nameColor, }) => {
    if (nameCategoryTag && nameColor) {
        return `${nameCategoryTag} - ${nameColor}`;
    }
    return nameCategoryTag || null;
};
export const formatPrice = (price) => {
    return price ? price / 100 : 0;
};
export const formattedSimples = (article, key = 'size') => {
    if (!article.simples) {
        return null;
    }
    return article.simples
        .map((s) => `${s[key]}|${checkAvailability(s.stockStatus)}`)
        .join(';');
};
export const buildFeatureFlagString = (...flags) => {
    return flags.filter(Boolean).join(', ');
};
export const mapArticleToGA4EcommerceItem = (item) => (Object.assign({ affiliation: null, article_size_recommendation: null, coupon: null, discount: null, early_access_item: null, feature_flag: null, index: null, item_info: null, is_sustainable: null, item_availability: null, item_brand: null, item_id: null, item_list_id: null, item_list_name: null, item_name: null, item_variant: null, location_id: null, price: null, product_delivery_dates: null, product_gender: null, promotion_id: null, quantity: null, recommended: null, size_availability: null, plus_exclusive: null }, item));
export const getSignalsFromQueryParams = (search) => {
    const params = new URLSearchParams(search);
    const parseQueryParam = (param) => (param ? param.split(',') : []);
    const brands = parseQueryParam(params.get('brand'));
    const categories = parseQueryParam(params.get('category')).map(Number);
    const tarGrp = parseQueryParam(params.get('tar_grp'));
    return {
        brands,
        categories,
        tarGrp,
    };
};
export const getTrackingDiscountedPrice = ({ specialPriceInCents, priceInCents, savingsPercent, }) => {
    const totalDiscountedPrice = priceInCents / 100 - specialPriceInCents / 100;
    if (Number.isFinite(totalDiscountedPrice)) {
        return parseFloat(totalDiscountedPrice.toFixed(2));
    }
    if (savingsPercent) {
        const derivedPriceInCents = specialPriceInCents / (1 - savingsPercent / 100);
        const fallbackDiscountedPrice = (savingsPercent / 100) * (derivedPriceInCents / 100);
        if (Number.isFinite(fallbackDiscountedPrice)) {
            return parseFloat(fallbackDiscountedPrice.toFixed(2));
        }
    }
    return null;
};
